import type { Ref } from 'react';
import CSS from './Login.module.css';
import { useClassNames } from '@CS/hooks';
import { useTranslations } from '@/hooks';
import Button from '@CS/components/Button';
import LogoImage from '@CS/assets/logo.png';

type LoginProps = {
  ref?: Ref<HTMLElement>;
  onLogin: () => void;
};

export const Login = ({ ref, onLogin }: LoginProps) => {
  const [title, description, button] = useTranslations([
    'LoginPage_Title',
    'LoginPage_Description',
    'LoginPage_Button'
  ]);

  return (
    <section
      ref={ref}
      aria-label="Login"
      className={useClassNames([CSS.loginScreen, ref && CSS.hidden])}
    >
      <img alt="Login" src={LogoImage} />

      <div className={CSS.infoContainer}>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>

      <Button onClick={onLogin} text={button} />
    </section>
  );
};
